import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AdditionalTranslation, GlobalTranslationsResponse } from '../models/globaltranslations-response.interface';
import { UserStoreService } from './user-store.service';

type TranslationResult = {
  status: string;
  code: string;
  shortDescription: string;
  fullDescription: string;
};

export interface ApiPutSurveyTranslationsGlobalResponse {
  organizationId: string;
  surveyId: string;
  translations: { item: { questionCode: string; culture: string; choiceValue: string | null; localizedText: string }; result: TranslationResult }[];
  additionalTranslations: { item: { label: string; culture: string; category: string; localizedText: string }; result: TranslationResult }[];
}

@Injectable({ providedIn: 'root' })
export class ApiSurveyTranslationsGlobalService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/surveytranslationsglobal';

  constructor(
    private http: HttpClient,
    private userStore: UserStoreService) {}

  getSurveyTranslationsGlobal(organizationId: string, surveyId: string | null = null): Observable<GlobalTranslationsResponse> {
    const params = new HttpParams()
      .set('organization', organizationId);
      //.set('surveyId', surveyId ?? '');

    return this.http.get<GlobalTranslationsResponse>(`${this.apiBaseUrl}${this.apiPath}`, {params})
  }

  updateSurveyTranslations(organizationId: string, translations: AdditionalTranslation[]): Observable<ApiPutSurveyTranslationsGlobalResponse> {
    //Prevent update of other surveys during development, unless the user is a SuperAdmin
    if(organizationId != 'a535f93d-f8c7-421d-a9c9-74f7a17e3761' && !this.userStore.isSuperAdmin()){
      return throwError(() => new Error('This organization/survey is not editable.'));
    }

    const request = {
      organization: organizationId,
      translations: translations
    }

    return this.http.put<ApiPutSurveyTranslationsGlobalResponse>(`${this.apiBaseUrl}${this.apiPath}`, request);
  }
}